



















import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import { DashboardWidgetHeaderColor } from '../../../types/enums/dashboard-widget-header-color';
import DashboardWidgetList from '../../DashboardWidgetList.vue';
import DashboardEmptyStateText from '../../DashboardEmptyStateText.vue';
import type { DashboardExpiringDocument } from '../../../types/dashboard-expiring-document';
import ExpiringSoonWidgetItem from './ExpiringSoonWidgetItem.vue';

export default defineComponent({
  name: 'ExpiringSoonWidget',
  components: {
    DashboardWidgetList,
    ExpiringSoonWidgetItem,
    DashboardEmptyStateText,
  },
  props: {
    expiringDocuments: {
      type: Array as PropType<DashboardExpiringDocument[]>,
      default: null,
    },
  },
  setup() {
    return {
      DashboardWidgetHeaderColor,
    };
  },
});
